import { staticHead } from "@/lib/route-head";
import { createFileRoute } from "@tanstack/react-router";
import GalleryDetail from "../pages/GalleryDetail";

export const Route = createFileRoute("/high-crowd-control-fence-barrier")({
  component: () => (
    <GalleryDetail forcedSlug="high-crowd-control-fence-barrier" />
  ),
  head: staticHead("/high-crowd-control-fence-barrier/"),
});
